import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { getInterviewById } from "../../../../Services/interviewService";


const baseUrl = process.env.REACT_APP_API_PATH;
// -------------------------------------------------------------------------------------------

function MyVerticallyCenteredModal(props,{reload}) {

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    status: props?.data?.candidateInterviewStatus??"",
    rating: props?.data?.rating??"",
    remark: props?.data?.remark??"",
    // roundType:""
  });
  console.log("pppppp",props);

  useEffect(() => {
    setFormData({
      status: props?.data?.candidateInterviewStatus??"",
    rating: props?.data?.rating,
    remark: props?.data?.remark
    })
  },[props])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    console.log(formData);
  };

  const handleTextareaChange = (e) => {
    setFormData({
      ...formData,
      remark: e.target.value,
    });
    console.log(formData);
  };

  const [loader,setLoader] = useState(false);

  const HandleSubmit = async (e) => {
    e.preventDefault()
    if (formData.remark && formData.rating && formData.status) {
      try {
        setLoader(true)
        console.log("first", props?.interviewid)
        const response = await axios.put(
          `${baseUrl}/ebench/interview/update_interview`,
          {
            interviewId: props.interviewid,
            candidateInterviewStatus: formData.status,
            rating: formData.rating,
            remark: formData.remark,
            interviewStatus: "COMPLETED",
          }
        );
        // console.log("reponse", response);
        if(response?.data){
          setFormData({
            status: "",
            rating: "",
            remark: "",
          });
          setTimeout(() => {
            toast.success("Feedback Submitted");
            setLoader(false)
            navigate('/candidate_dashboard')
          },1000)
          getInterviewById(props.interviewid)

          props.setReload(!reload)
          props.onHide()
        }
        

        // console.log(response.data)
      } catch (error) {
        console.error("Error at feedback:", error);
        toast.error(error?.response?.data?.status?.message??"error occured in feedback");
        setTimeout(() => {
          setLoader(false)
        })
        setFormData({
          status: "",
          rating: "",
          remark: "",
        });
      }
    } else {
      toast.error("Fill all details");
    }
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-10w"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "20px" }}>
          Interview Feedback
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={HandleSubmit}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {/* ----------------------Status ------------------------------ */}
            <select
              style={{
                fontSize: "16px",
                border: "1px solid #ccc",
                padding: "5px",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
                color: "#333",
                width: "45%"
              }}
              required
              name="status"
              value={formData?.status}
              onChange={handleChange}>

              <option selected hidden value="">Interview Status</option>
              <option value="SELECT">Selected</option>
              <option value="REJECT">Rejected</option>
              <option value="NEXT_ROUND">Next Round</option>
              <option value="ONHOLD">On Hold</option>
            </select>

            {/* ----------------------Rating ------------------------------ */}
            <span style={{ paddingInline: "10px", width: "50%" }}>
              <select style={{
                fontSize: "16px",
                border: "1px solid #ccc",
                padding: "5px",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
                color: "#333",
                width: "100%"
              }} required
                name="rating"
                value={formData?.rating}
                onChange={handleChange}
              >
                <option selected hidden value="">Score</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>{" "}
            </span>
          </div>


          {/* {=========================NEXT ROUND==============================} */}

          {/*  formData.status ==="NEXT_ROUND" && <div style={{margin:"15px 0 0 12px"}}> */}
          {/* ----------------------Status ------------------------------ */}
          {/* <select  */}
          {/* style={{ */}
          {/* fontSize: "16px", */}
          {/* border: "1px solid #ccc", */}
          {/* padding: "5px", */}
          {/* borderRadius: "4px", */}
          {/* backgroundColor: "#f9f9f9", */}
          {/* color: "#333", */}
          {/* width: "46%"
                  }}
                  required 
                  name="roundType" 
                  value={formData.roundType} 
                  onChange={handleChange}> */}

          {/* <option selected disabled value="">Round Type</option>
            <option value="HR">HR</option>
            <option value="TECHNICAL">Technical</option>
          </select>
          
        </div> */ }

          {/* ---------------Form------------- */}
          <label style={{ margin: "20px 0 0 12px" }} htmlFor="textarea">
            Feedback:
          </label>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
            <textarea
              required
              onChange={handleTextareaChange}
              maxLength={200}
              value={formData.remark}
              style={{ width: "94%", height: "100px", margin: "5px 0 0 0" }}
            ></textarea>
          </div>

          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "10px" }}>
            <Button type="submit" className="add_skill_btn" disabled={loader} >
              {loader ? 'Loading' : 'Submit'} 
            </Button>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>

      </Modal.Footer>
    </Modal>
  );
}

function Feedback({ interviewId, reload, setReload, disable, feedData, recieve }) {
  const [modalShow, setModalShow] = React.useState(false);

  useEffect(() => {
    if(modalShow==false){
      setReload(!reload)
    }
  },[modalShow])
  return (
    <>

      <Button className="btn-primary-custom " disabled={disable} onClick={() => setModalShow(true)}>
      {feedData ? 'Update Feedback' : 'Feedback' }
      </Button>

      <MyVerticallyCenteredModal
        show={modalShow}
        setReload={setReload}
        interviewid={interviewId}
        data={recieve}
        reload={reload}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Feedback;
